/**
 * Socium Auth storage
 *
 * @package OneSoft
 * @author AndriyGoodCoder
 */
const SociumAuthHelper = function () {
    this.rendomStringLength = 16;
}

SociumAuthHelper.prototype.Serialize = function (obj, prefix) {
    let str = [],
        p;
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            let k = prefix ? prefix + "[" + p + "]" : p,
                v = obj[p];
            str.push((v !== null && typeof v === "object") ?
                this.Serialize(v, k) :
                encodeURIComponent(k) + "=" + encodeURIComponent(v));
        }
    }
    return str.join("&");
}

SociumAuthHelper.prototype.GetRandomString = function () {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for (let i = 0; i < this.rendomStringLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

SociumAuthHelper.prototype.GetUrlParameter = function (name) {
    let queryString = window.location.href.split('?')[1] ?? '';
    let urlParams = new URLSearchParams(queryString);
    let value = urlParams.get(name);
    return value;
}

SociumAuthHelper.prototype.ConvArrToObj = function (array) {
    let thisEleObj = new Object(); // eslint-disable-line
    if (typeof array === "object" && array !== null) {
        for (var i in array) {
            var thisEle = this.ConvArrToObj(array[i]);
            thisEleObj[i] = thisEle;
        }
    } else if (array === null) {
        thisEleObj = null;
    } else {
        thisEleObj = array;
    }
    return thisEleObj;
};

/**
* show message on console
*
* @param string message message for show on console
* @param string type type of message (error|success)
*/
SociumAuthHelper.prototype.ShowMessage = function (message, type) {
    if (typeof (type) === 'undefined')
        var type = 'error'; // eslint-disable-line
    switch (type) { // eslint-disable-line
        case 'error':
            throw new Error(message);
            break; // eslint-disable-line
        case 'success':
            console.log('%c%s', 'color: green;', message);
            break;
    }
}

/**
* check if string is valid json
*
* @param  string  text string for check
* @return bool    (true|false)
*/
SociumAuthHelper.prototype.CheckIfStringIsJson = function (text) {
    if (/^[\],:{}\s]*$/.test(text.replace(/\\["\\\/bfnrtu]/g, '@'). // eslint-disable-line
        replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']'). // eslint-disable-line
        replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
        return true;
    } else {
        return false;
    }
}


/**
* get current timestamp
*
* @return integer
*/
SociumAuthHelper.prototype.GetCurrentTimestamp = function () {
    return Math.floor(Date.now() / 1000);
}

export const Helper = (params) => {
    return new SociumAuthHelper();
};